import React from 'react';
import { defaultTemplate } from 'core/hoc';
import esRolesSvg from 'themes/img/es-roles.svg';

const UnauthorizedTemplate = ({ routerStore, t }) => {
	return (
		<div className="page-404">
			<div className="w--400--px align--h--center type--center ">
				<img className="display--b spc--bottom--med" src={esRolesSvg} />
				<p className="spc--bottom--med w--250--px align--h--center">{t('NOTAUTHORIZED')}</p>
				<a className="btn btn--med btn--primary" onClick={() => routerStore.goTo('master.app.main.home')}>
					{t('GOBACKTOHOME')}
				</a>
			</div>
		</div>
	);
};

export default defaultTemplate(UnauthorizedTemplate);
